export default "__VITE_ASSET__Di85aNup__"